import OSS from 'ali-oss' // npm install ali-oss
import co from 'co' // npm install -S co ali-oss
/**
 *
 * @param {*} data ali data
 * @param {*} file dom file对象
 */
export const upload = (data, file) => {
  return new Promise((resolve, reject) => {
    const client = new OSS({
      region: 'oss-cn-hangzhou',
      accessKeyId: data.AccessKeyId,
      accessKeySecret: data.AccessKeySecret,
      bucket: data.Bucket, // data.Bucket
      stsToken: data.SecurityToken
    })
    co(function * () {
      yield client.multipartUpload(data.Name, file, {
        progress: function * () {}
      })
    }).then(() => {
      resolve()
    }).catch((err) => {
      reject(err)
    })
  })
}
